import React, { Component } from 'react';
import { FormControl } from 'react-bootstrap';
import {bindActionCreators} from 'redux';
import {history} from '../../store';
import {connect} from 'react-redux';
import {loginAction} from '../../Actions';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import {routeName} from '../../Service/env';
import {audioFunc} from "../../Service/helper";
import {ws} from "../../App";

const styles={
    Button: {
        color: '#fff',
        borderRadius: '5px',
        fontSize:'medium',
        marginBottom:'3%',
        textTransform:'none'
    },
};

class Login extends Component {
    constructor(props){
        super(props);
        this.state={
            credentials:{},
            lblErrorMsg:''
        }
    }
    handleChange=(e)=>{
        const { name,value } = e.target;
        const { credentials } = this.state;
        credentials[name]=value;
        this.setState({
            credentials,
            lblErrorMsg:''
        })
    };

    onLogin=()=>{
        const { credentials } = this.state;
        if ((Object.keys(credentials).length <= 1) || (credentials.Email === "") || (credentials.Password === ""))
            this.setState({
                lblErrorMsg: 'Both Fields are Required.'
            });
        else {
            this.props.loginAction(this.state.credentials).then((data) => {
                if(!data.results.ResponseCode)
                {
                    this.setState({
                        lblErrorMsg: data.results.Message
                    });
                }
                else if (data.results.ResponseCode && data.results.BusinessUser && data.results.Token) {
                    audioFunc(true,false,'')
                    if (
                        data.results &&
                        data.results.AppUser &&
                        data.results.AppUser.UserId
                    ) {
                        let date = new Date();

                        ws.json({
                            token_id: localStorage.getItem("token"),
                            user_id: data.results.AppUser.UserId.toString(),
                            type: "identity",
                            isOnline: 1,
                            msgid: date.getTime().toString().slice(4),
                        });
                    }
                    history.push(`/${routeName}/Dashboard/Overview`);
                }
                else {
                    this.setState({
                        lblErrorMsg: "We don't find a user with these credentials in Business Portal."
                    });
                }
            }).catch((err)=>{
                console.log(err);
            });
        }

    };
    onForgotPassword=()=>{
        history.push(`/${routeName}/ForgotPassword`);
    };

    render(){
        const { credentials,lblErrorMsg } = this.state;
        const { classes } = this.props;

        return(
            <section className="container">
                <div className="row">
                    <div className="col-8 text-center">
                    </div>
                    <div className="col-8">
                        <h1 style={{color:'#851679'}} >Login To Dashboard</h1>
                        <div className="error">
                            {
                                ((lblErrorMsg!=='')?<span>{lblErrorMsg}</span>:<span/>)
                            }
                        </div>
                        <div className="form-group">
                            <FormControl type={'text'} autoComplete={'off'} placeholder="Username"
                                         name="Email"
                                         onChange={this.handleChange}
                                         value={credentials.Email}
                            />
                            <span className="error pull-right">
                    </span>
                        </div>
                        <div className="form-group">
                            <FormControl type={'password'} placeholder="Password"
                                         onChange={this.handleChange}
                                         onKeyDown={(e)=>{
                                             if(e.keyCode===13)
                                                this.onLogin()
                                         }}
                                         name={"Password"}
                                         value={credentials.Password}
                            />
                            <span className="error pull-right">
                    </span>
                        </div>
                        <div className="form-group text-center">
                            <a onClick={this.onForgotPassword}><u>Forgot
                                Password?</u></a>
                        </div>
                        <div className="form-group text-right mt-30">
                            <Button className={classes.Button} color={'primary'} variant={'contained'} onClick={this.onLogin}>Log in</Button>
                        </div>
                    </div>
                </div>
              
            </section>
        )
    }
}
const matchDispatchToProps=(dispatch)=> {
    return bindActionCreators({
        loginAction
    },dispatch)
};
export default connect(null,matchDispatchToProps)(withStyles(styles)(Login));
